import type { ImageType } from '@/app/types';
import { detectImageTypeByBuffer } from '../detect-image-type-by-buffer';

export const getInviteLink = (inviterId: string, redirect: string) => {
  const origin = window.location.origin;
  const inviteSearch = `utm_source=referral&utm_medium=invitefriends&utm_campaign=long_term&utm_term=${inviterId}&utm_content=${redirect}`;
  let search = '';
  if (window.location.search) {
    search = `${window.location.search}&${inviteSearch}`;
  } else {
    search = `?${inviteSearch}`;
  }
  return `${origin}${redirect}${search}`;
};

// 回填场景的图片id
export const getBackfillImageId = (index: number) => `backfill-${index}-${performance.now()}`;

/**
 * 阻止文本中的邮箱点击唤起发邮件
 */
export const preventTxtLinkEmailClick = (e: React.MouseEvent<HTMLDivElement>) => {
  if ((e.target as HTMLAnchorElement).href?.startsWith('mailto:')) {
    e.preventDefault();
  }
};

export async function detectImageType(file: File): Promise<ImageType | null> {
  // 检查文件是否有效
  if (!file || file.size === 0) {
    console.error('Invalid file: File is empty or undefined', file);
    return null;
  }

  const bytesToRead = Math.min(12, file.size);
  const buffer = await file.slice(0, bytesToRead).arrayBuffer();
  return detectImageTypeByBuffer(buffer);
}
